import React from "react";
import { Layout } from '../../components/Layout';
import WillBeBackPage from '../WillBeBackPage'

function AppleTradeIn(){
    return(
        <Layout bgThemeVariant="light" iconColor="gray">
            <WillBeBackPage
                pageContent='Apple Trade In'
            />
   
        </Layout>
    )
}

export default AppleTradeIn;